// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, Input, OnChanges } from '@angular/core';
import { FeatureToggle } from '@coa/app/shared/feature-toggle/models/feature.toggle';
import { Observable } from 'rxjs';
import { DateRangeFilter } from '@coa/app/shared/filters/select-date-range/models/date-range-filter';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import { FeatureToggleService } from '@coa/app/shared/feature-toggle/services/feature-toggle.service';

@Component({
  selector: 'coa-dashboard-content',
  templateUrl: './dashboard-content.component.html',
  styleUrls: ['./dashboard-content.component.scss'],
})
export class DashboardContentComponent implements OnChanges {
  @Input() clientId: string;
  @Input() categoryId: string;
  @Input() dateRange: DateRangeFilter;

  locationPreferencesFeatureToggle$: Observable<boolean>;
  floorsFeatureToggle$: Observable<boolean>;
  groupsFeatureToggle$: Observable<boolean>;

  constructor(
    private store$: Store,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private featureToggleService: FeatureToggleService) {
  }

  ngOnChanges(): void {
    if (this.clientId) {
      this.locationPreferencesFeatureToggle$ = this.featureToggleService.isFeatureAdded(FeatureToggle.LOCATION_PREFERENCES_ENABLED, this.clientId);
      this.floorsFeatureToggle$ = this.featureToggleService.isFeatureAdded(FeatureToggle.FLOORS_VIEW_ENABLED, this.clientId);
      this.groupsFeatureToggle$ = this.featureToggleService.isFeatureAdded(FeatureToggle.DYNAMIC_GROUPS_ENABLED, this.clientId);
    }
  }
}
